import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dynamic%20sports%20fans%20cheering%20in%20stadium%20with%20warm%20golden%20hour%20lighting%2C%20abstract%20geometric%20light%20streaks%2C%20dramatic%20atmosphere%2C%20red%20and%20amber%20color%20scheme%2C%20cinematic%20scale%2C%20emotional%20sports%20moment%20captured%20with%20motion%20blur%2C%20clean%20composition&width=1920&height=800&seq=cta-bg-01&orientation=landscape"
          alt="加入米乐体育"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/60 to-black/75"></div>
      </div>

      <div className="relative z-10 max-w-[1400px] mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 mb-4">
          准备好开启您的体育之旅了吗？
        </h2>
        <p className="text-sm md:text-base text-background-50/70 max-w-lg mx-auto mb-8">
          立即注册米乐体育，领取新用户专属福利，畅享全球顶级赛事直播与竞猜体验
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/register"
            className="px-10 py-3.5 rounded-full text-base font-bold bg-primary-500 text-background-50 whitespace-nowrap cursor-pointer transition-all duration-200 hover:bg-primary-600 hover:scale-105"
          >
            免费注册
          </Link>
          <Link
            to="/app"
            className="px-10 py-3.5 rounded-full text-base font-medium border border-background-50/40 text-background-50 whitespace-nowrap cursor-pointer transition-all duration-200 hover:bg-background-50/10"
          >
            下载APP
          </Link>
        </div>
      </div>
    </section>
  );
}